import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import type * as React from 'react';

type PendulampProps = React.ComponentProps<'div'>;

export function Pendulamp({ className, ...props }: PendulampProps) {
	return (
		<div
			aria-hidden="true"
			className={cn(
				'pointer-events-none relative inset-x-0 -top-6 flex justify-center opacity-60',
				className,
			)}
			{...props}
		>
			<style>{`@keyframes lamp-sway {
                    0%, 100% { transform: rotate(-4deg); }
                    50%      { transform: rotate(4deg); }
                  }
                  @keyframes lamp-glow {
                    0%, 100% { opacity: 0.35; }
                    50%      { opacity: 0.8; }
                  }
                  @media (prefers-reduced-motion: reduce) {
                    .lamp-swing { animation: none !important; }
                    .lamp-glow { animation: none !important; }
                  }`}</style>
			<div className="lamp-swing flex origin-top animate-[lamp-sway_5s_ease-in-out_infinite] flex-col items-center">
				<div className="h-16 w-1 rounded-full bg-foreground" />
				<Iconify
					icon="lucide:lamp-ceiling"
					className="-mt-1 size-14 text-foreground"
				/>
				<div className="lamp-glow mt-1 h-16 w-28 animate-[lamp-glow_3.5s_ease-in-out_infinite] bg-linear-to-b from-primary/30 via-primary/10 to-transparent blur-[2px] [clip-path:polygon(32%_0,68%_0,100%_100%,0_100%)]" />
			</div>
		</div>
	);
}
